import React  from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { LuArrowRightFromLine, LuLogOut, LuUser, LuUser2 } from 'react-icons/lu';
import Sidebar from '../sidebar';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { FaAngleDown, FaChevronDown } from 'react-icons/fa';
import { AiOutlineUnlock, AiOutlineUser } from 'react-icons/ai';
import { IoMdPower } from 'react-icons/io';
import { SlLockOpen } from 'react-icons/sl';
import methodModel from '../../../methods/methods';


function Html({
  isOpen,
  toggle,
  // searchHandle,
  // search,
  user,
  isOpen1,
  // searchChange,
  // clear,
  Logout,
  // messageCount,
}) {
  return (
     <nav
     component="header"
      className={`${
        isOpen ? 'min-sidebar w-[calc(100%-106px)]' : 'sidebar-class w-[calc(100%-285px)] '
      } h-[67px] shadow-[0_4px_20px_-2px_rgba(0,0,0,0.05)] py-1.5 bg-white border border-gray-100 top-[20px] fixed transition-[width] duration-300 ml-auto right-[20px] z-10 flex items-center !px-5 rounded-[20px]
      `}
    >
      {/* <button
        onClick={toggle}
        className="btntoggle h-9 w-9 shrink-0 shadow-btn hover:shadow-none p-1 rounded-lg border border-gray-100 !text-primary bg-white"
      >
        {!isOpen ? (
          <FiMenu className="w-full h-full" />
        ) : (
          <LuArrowRightFromLine className="w-full h-full" />
        )}
      </button> */}
{/* 
      <div className="flex items-center gap-2  ml-auto">
               <Tooltip placement='left' title="Profile">
                  <Link to="/profile">
                    <div className=' border cursor-pointer hover:bg-primary  rounded-lg bg-[#f8f9fa]  w-10 h-10  flex items-center justify-center text-lg hover:text-white text-primary'>
                      <LuUser2 />
                    </div>
                    </Link>
                </Tooltip>
                <div className='h-5 w-[2px] bg-[#F2F2F2]'>

                </div>

                <div>
              

                  <span
                      id="logoutBtn"
                      onClick={() => Logout()}
                     className='flex items-center justify-center text-white gap-2 bg-red-500 cursor-pointer px-4 py-2 rounded-lg'
                    >
                      <LuLogOut />
                      {' '}
                      Logout
                </span>
                </div>
     
      </div> */}
 
 <div className='ml-auto'>
  <span id="logoutBtn" className="d-none" onClick={() => Logout()}></span>
  <Menu>
      <MenuButton className="flex gap-3 justify-between items-center bg-[#FFF9E9] hover:bg-[#FFF2CC] rounded-full p-2 pr-3 transition-colors duration-200">
        <div className='flex items-center gap-2'>
        <img src={methodModel.userImg(user?.image)} className='w-[38px] min-w-[38px] h-[38px] rounded-full object-cover border border-[#CC9900]/20'/>
        <div>
          <h2 className='text-sm text-[#2D2D2D] text-left font-[600]'>{user?.firstName} {user?.lastName}</h2>
          <p className='text-xs text-[#7C7C7C] text-left'>{user?.email}</p>
          </div>
          </div>
          <FaChevronDown className='text-[#CC9900] text-sm transition-transform duration-200 group-data-[open]:rotate-180'/>
      </MenuButton>
      <MenuItems anchor="bottom" className="min-w-[190px] bg-white/80 backdrop-blur-md rounded-[15px] z-50 border border-gray-100/50 shadow-[0_10px_30px_rgba(0,0,0,0.08)] p-2 mt-2">
      <div className='bg-white rounded-[15px] p-2'>
        <MenuItem>
         <Link to="/profile">
          <p className='group text-sm text-[#2D2D2D] rounded-lg text-left hover:bg-[#FFF9E9] flex items-center gap-1.5 cursor-pointer px-2.5 py-2 transition-all duration-150'><AiOutlineUser className='group-hover:text-[#CC9900] text-lg text-gray-400' />  Profile</p>
          </Link>
        </MenuItem>
            {/* <MenuItem>
          <p className='group text-sm text-[#2D2D2D] rounded-lg text-left hover:bg-[#FFF9E9] flex items-center gap-1.5 cursor-pointer px-2 py-1.5'> <SlLockOpen className='group-hover:text-[#CC9900] text-lg' /> Chnage Password</p>
        </MenuItem> */}
            <MenuItem>
          <p onClick={() => Logout()} className='text-sm text-[#FF0000] rounded-lg text-left hover:bg-[#ffebeb] flex items-center gap-1.5 cursor-pointer px-2.5 py-2 transition-all duration-150'> <IoMdPower className='text-lg' /> Logout</p>
        </MenuItem>
        </div>
      </MenuItems>
    </Menu>
    </div>

      {isOpen1 ? (
        <div className="w-100 mobi-dropdown">
          <Sidebar />
        </div>
      ) : (
        <></>
      )}
    </nav>
  );
}

export default Html;
